import * as auth from '../actions/authentication';
import * as userActions from '../actions/user';
import {CurrentUser} from '../models/current-user';

export interface State {
  working: boolean;
  currentUser: CurrentUser;
  aliasingUser: string;
  isAliasing: boolean;
  loggedIn: boolean;
  isError: boolean;
  isSuccess: boolean;
  message: string;
  uploadProgress: number;
}

export const initialState: State = {
  working: false,
  currentUser: {},
  aliasingUser: '',
  isAliasing: false,
  loggedIn: false,
  isError: false,
  message: '',
  isSuccess: false,
  uploadProgress: 0
};

export function reducer(state = initialState, action: auth.Actions | userActions.Actions): State {
  let newState: State;

  switch (action.type) {

    case auth.LOGIN:
      newState = Object.assign({}, state);
      newState.working = true;
      return newState;

    case auth.LOGIN_COMPLETE:
      newState = Object.assign({}, state);
      newState.working = false;
      newState.currentUser = action.payload;
      newState.loggedIn = true;
      return newState;

    case auth.ALIAS_USER:
      newState = Object.assign({}, state);
      newState.aliasingUser = action.payload;
      newState.working = true;
      return newState;

    case auth.ALIAS_USER_COMPLETE:
      newState = Object.assign({}, state);
      newState.working = false;

      if (action.payload) {
        newState.isAliasing = true;
        newState.currentUser = action.payload;
      } else {
        newState.isError = true;
        newState.message = "Failed aliasing user.";
      }

      return newState;

    case auth.LOGOUT:
      newState = Object.assign({}, initialState);
      newState.currentUser = new CurrentUser();
      newState.loggedIn = false;
      return newState;

    case auth.LOGOUT_COMPLETE:
      newState = Object.assign({}, initialState);
      newState.isError = state.isError;
      newState.message = state.message;
      return newState;

    case auth.RESET_PASSWORD:
      newState = Object.assign({}, state);
      newState.working = true;
      return newState;

    case auth.RESET_PASSWORD_COMPLETE:
      newState = Object.assign({}, state);
      newState.working = false;
      return newState;

    case auth.CHANGE_PASSWORD:
      newState = Object.assign({}, state);
      newState.working = true;
      return newState;

    case auth.CHANGE_PASSWORD_COMPLETE:
      newState = Object.assign({}, state);
      const tempUser = Object.assign({}, state.currentUser);
      tempUser.changePw = false;
      newState.currentUser = tempUser;
      newState.working = false;
      return newState;

    case auth.SHOW_ERROR:
      newState = Object.assign({}, state);
      newState.isError = true;
      newState.message = getErrorMessage(action.payload);
      newState.working = false;
      return newState;

    case auth.SHOW_SUCCESS:
      newState = Object.assign({}, state);
      newState.isSuccess = true;
      newState.message = action.payload;
      newState.working = false;
      return newState;

    case auth.HIDE_MESSAGE:
      newState = Object.assign({}, state);
      newState.isError = false;
      newState.isSuccess = false;
      newState.message = '';
      return newState;

    case auth.SET_UPLOAD_PROGRESS:
      newState = Object.assign({}, state);
      newState.uploadProgress = action.payload;
      return newState;

    case userActions.ACCEPT_USER_AGREEMENT_COMPLETE:
      newState = Object.assign({}, state);
      const usr = Object.assign({}, state.currentUser);
      usr.acceptedAgreement = action.payload;
      newState.currentUser = usr;
      return newState;


    case 'ERROR':
      newState = Object.assign({}, state);
      newState.working = false;
      return newState;

    default:
      newState = Object.assign({}, state);
      return newState;
  }
}

function getErrorMessage(e: any) {
  if (!e) { return 'There was an error processing the request.'; }
  if (typeof e === 'string') { return e; }
  if (e.error && e.error.error_description) {
    return e.error.error_description;
  }
  if (e.error && e.error.message) {
    return e.message + e.error.message;
  }
  return e.message;
}

export const getAuthLoggedIn = (state: State) => state.loggedIn;
export const getAuthIsAliasing = (state: State) => state.isAliasing;
export const getAuthWorking = (state: State) => state.working;
export const getAuthFirstName = (state: State) => state.currentUser.firstname;
export const getAuthLastName = (state: State) => state.currentUser.lastname;
export const getAuthFullName = (state: State) => state.currentUser.firstname + ' ' + state.currentUser.lastname;
export const getAuthRole = (state: State) => state.currentUser.role;
export const getAuthUsername = (state: State) => state.currentUser.username;
export const getAuthIsAdmin = (state: State) => state.currentUser.role === 'Administrator'
  || state.currentUser.role === 'Super Administrator';
export const getAuthIsSuperAdmin = (state: State) => state.currentUser.role === 'Super Administrator';
export const getAuthMustChangePassword = (state: State) => state.currentUser.changePw;
export const getAuthIsUser = (state: State) => state.currentUser.role === 'Administrator'
  || state.currentUser.role === 'Super Administrator' || state.currentUser.role === 'User';
export const getIsError = (state: State) => state.isError;
export const getIsSuccess = (state: State) => state.isSuccess;
export const getMessage = (state: State) => state.message;
export const getProgress = (state: State) => state.uploadProgress;
export const getHasAcceptedAgreement = (state: State) => state.currentUser.acceptedAgreement;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/reducers/authentication.ts